import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { languages } from '../i18n/languages';
import './LanguageSwitcher.css';

const LanguageSwitcher: React.FC = () => {
  const { currentLang, setLanguage, t } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const langOptions = Object.entries(languages).map(([code, lang]) => ({
    code,
    name: lang.name,
    flag: lang.flag
  }));

  return (
    <div className="lang-switcher" ref={dropdownRef}>
      <button className="lang-switch-btn" onClick={() => setIsOpen(!isOpen)}>
        <span className="lang-icon">🌐</span>
        <span className="lang-text">{t.name}</span>
        <span className="lang-arrow">▼</span>
      </button>
      <div className={`lang-dropdown ${isOpen ? 'active' : ''}`}>
        {langOptions.map((lang) => (
          <div
            key={lang.code}
            className={`lang-option ${currentLang === lang.code ? 'active' : ''}`}
            onClick={() => {
              setLanguage(lang.code);
              setIsOpen(false);
            }}
          >
            <span className="lang-flag">{lang.flag}</span>
            <span className="lang-name">{lang.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LanguageSwitcher;
